import React, { useCallback } from 'react'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import ImpressionsBudgetSection from '../../../../../../Multiplatform/UploadAdCreative/ImpressionsBudgetSection'

import { IMPRESSIONS } from '../../../../../../Multiplatform/UploadAdCreative/fields'

const stepFields = [IMPRESSIONS]

const ImpressionsStep = ({ formik, handleStepChange, remainingImpressions }) => {
  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle={'How many impressions would you like this new ad set to deliver?'} handleContinue={handleContinue}>
      <ImpressionsBudgetSection remainingImpressions={remainingImpressions} formik={formik} />
    </Step>
  )
}

export default ImpressionsStep
